import * as React from 'react';

function Alert(props) {
	return (
		<svg
			aria-label={`alert icon`}
			xmlns={'http://www.w3.org/2000/svg'}
			width={'36'}
			height={'30'}
			viewBox={'0 0 36 30'}
			fill={'none'}
			{...props}
		>
			<title>alert icon</title>
			<path
				fillRule={'evenodd'}
				clipRule={'evenodd'}
				d={'M18.5858 0.608857C18.1591 -0.106925 17.1225 -0.106923 16.6959 0.608858L0.368697 28.0036C-0.0683057 28.7368 0.460026 29.6667 1.3136 29.6667H33.9681C34.8217 29.6667 35.35 28.7368 34.913 28.0036L18.5858 0.608857ZM17.5549 1.12083C17.5937 1.05575 17.688 1.05575 17.7267 1.12082L34.054 28.5155C34.0938 28.5822 34.0457 28.6667 33.9681 28.6667H1.3136C1.23601 28.6667 1.18797 28.5822 1.2277 28.5155L17.5549 1.12083ZM16.0703 10.4677C16.036 9.57665 16.7491 8.83559 17.6408 8.83559C18.5326 8.83559 19.2457 9.57665 19.2114 10.4677L18.8524 19.8032C18.8273 20.4541 18.2923 20.969 17.6408 20.969C16.9894 20.969 16.4544 20.4541 16.4293 19.8032L16.0703 10.4677ZM19.3906 24.4441C19.3906 25.4106 18.6071 26.1941 17.6406 26.1941C16.6741 26.1941 15.8906 25.4106 15.8906 24.4441C15.8906 23.4776 16.6741 22.6941 17.6406 22.6941C18.6071 22.6941 19.3906 23.4776 19.3906 24.4441Z'}
				fill={'#C30000'}
			/>
		</svg>
	);
}

export default Alert;
